const { createFeatureFlagSwitch } = require('lib/featureFlagSwitch');

export const launchDarklyKey = 'display-video-date';

export const {
  hook: useDisplayVideoDate,
  hoc: withDisplayVideoDate,
} = createFeatureFlagSwitch({ key: launchDarklyKey, name: 'articleVideoDateEnabled' });

